"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _Step = require("@mui/material/Step");
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dataCy = exports.dataCy = "StepIcon";
var styles = function styles(theme) {
  return {
    root: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      borderWidth: 2,
      borderColor: theme.palette.inactive.main,
      borderStyle: 'dashed',
      boxSizing: 'border-box'
    },
    active: {
      background: theme.palette.success.main,
      border: 'none'
    },
    completed: {
      background: theme.palette.draft.main,
      border: 'none'
    },
    color: {
      background: function background(props) {
        var _theme$palette$props$;
        return (_theme$palette$props$ = theme.palette[props.color]) === null || _theme$palette$props$ === void 0 ? void 0 : _theme$palette$props$.main;
      },
      border: 'none'
    }
  };
};
var StepIcon = function StepIcon(_ref) {
  var classes = _ref.classes,
    color = _ref.color;
  var _useStepContext = (0, _Step.useStepContext)(),
    active = _useStepContext.active,
    completed = _useStepContext.completed;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-cy": dataCy,
    "data-cy-state": active ? "active" : completed ? "completed" : "draft",
    className: (0, _clsx2["default"])(classes.root, _defineProperty(_defineProperty(_defineProperty({}, classes.active, active && !color), classes.completed, completed && !color), classes.color, color))
  });
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(StepIcon);